import { resolveAssetUrl } from "@/lib/api";
import useSettings from "@/lib/useSettings";
import { ExternalLink } from "lucide-react";

export default function PRMBanner() {
  const settings = useSettings();
  const prmUrl = settings.prm_url || "https://prm1978.pl/";
  const logo = settings.prm_logo_url;

  return (
    <section
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(90deg, rgba(255,106,26,0.10) 0%, rgba(12,10,9,0) 30%, rgba(12,10,9,0) 70%, rgba(255,106,26,0.10) 100%), rgba(12,10,9,0.85)",
        borderTop: "1px solid var(--sr-border)",
        borderBottom: "1px solid var(--sr-border)",
      }}
      data-testid="prm-banner"
    >
      <div className="max-w-6xl mx-auto px-5 py-6 md:py-8">
        <a
          href={prmUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-5 md:gap-8 hover:opacity-90 transition-opacity group cursor-pointer"
          data-testid="prm-banner-link"
        >
          {logo ? (
            <img
              src={resolveAssetUrl(logo)}
              alt="Polski Ruch Motocyklowy 1978"
              className="flicker flex-shrink-0"
              style={{
                width: "clamp(64px, 8vw, 110px)",
                height: "clamp(64px, 8vw, 110px)",
                objectFit: "contain",
                filter: "drop-shadow(0 0 18px rgba(255,106,26,0.35))",
              }}
              data-testid="prm-banner-logo"
            />
          ) : null}
          <div className="flex-1">
            <p
              className="font-nav uppercase tracking-[0.2em]"
              style={{ color: "var(--sr-fire-2)", fontSize: "clamp(0.65rem, 1vw, 0.8rem)" }}
            >
              Scythe Riders jest członkiem
            </p>
            <h2
              className="font-display mt-1 group-hover:text-[var(--sr-fire)] transition-colors"
              style={{ color: "var(--sr-cream)", fontSize: "clamp(1rem, 2.2vw, 1.75rem)" }}
            >
              POLSKIEGO RUCHU MOTOCYKLOWEGO 1978
            </h2>
            <div
              className="mt-2 inline-flex items-center gap-1.5 font-nav uppercase tracking-widest"
              style={{ color: "var(--sr-muted)", fontSize: "clamp(0.6rem, 0.9vw, 0.75rem)" }}
            >
              prm1978.pl <ExternalLink size={11} />
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}
